import axios from "./axios";

export const createMedias = async (projectId, files, onUploadProgress) => {
  const formData = new FormData();
  for (const file of files) {
    formData.append(file.name, file);
  }
  await axios.post(`/project/${projectId}/media`, formData, {
    onUploadProgress
  });
};

export const deleteMedia = async (projectId, mediaId) => {
  return await axios.delete(`/project/${projectId}/media/${mediaId}`);
};
